import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import "../../layout/Footer/footer.css";

import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaFacebookF, FaInstagram, FaYoutube, FaTiktok } from "react-icons/fa";

import Mapa from "../Mapa/Mapa";
import Input from "../../elements/inputs/Input";
import Button from "../../elements/buttons/Button";
import { apiGet } from "../../../api/api";
import { ASESORIA_FORM } from "../../../constants/forms/asesoria";
import { asesoriaSchema } from "../../../models/forms/asesoriaSchema";
import useForm from "../../../hooks/UseForm";
import { setErrorFormSimpleUtil } from "../../../utilities/forms/errors";

const Asesoria = () => {
  const [isClient, setIsClient] = useState(false);
  const [loading, setLoading] = useState(false);
  const [footer, setFooter] = useState([]);

  useEffect(() => {
    apiGet("/footers")
      .then((res) => setFooter(res.flatMap((item) => item)))
      .catch((err) => console.error("❌ Error al obtener footers:", err));
    setIsClient(true);
  }, []);

  const { values, errors, touched, handleBlur, handleChange, isValid, resetForm } = useForm(
    ASESORIA_FORM,
    asesoriaSchema
  );

  const iconMap = { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaFacebookF, FaInstagram, FaYoutube, FaTiktok };
  const iconComponents = { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope };

  if (!isClient) return null;

  const handleSubmit = async (formValues) => {
    if (loading) return;
    setLoading(true);

    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE}/asesoria`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formValues),
      });

      const result = await response.json();

      if (response.ok) {
        resetForm();
        await Swal.fire({
          icon: "success",
          title: footer[0]?.alertas?.alertaSuccess?.titulo || "¡Enviado!",
          text: footer[0]?.alertas?.alertaSuccess?.texto || "Nos pondremos en contacto contigo pronto.",
          confirmButtonColor: footer[0]?.alertas?.alertaSuccess?.colorBoton || "#0b1260",
          confirmButtonText: footer[0]?.alertas?.alertaSuccess?.textoBoton || "Aceptar",
        });
      } else {
        await Swal.fire({
          icon: "error",
          title: footer[0]?.alertas?.alertaError?.titulo || "Error",
          text: result.message || footer[0]?.alertas?.alertaError?.texto,
          confirmButtonColor: footer[0]?.alertas?.alertaError?.colorBoton || "#d33",
          confirmButtonText: footer[0]?.alertas?.alertaError?.textoBoton || "Cerrar",
        });
      }
    } catch {
      await Swal.fire({
        icon: "error",
        title: "Error de conexión",
        text: "No pudimos conectar con el servidor.",
        confirmButtonColor: "#d33",
        confirmButtonText: "Cerrar",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="footer container-fluid contacto-section">
      <div id="asesoria-quality-seal" className="footer-content row">
        {/* FORM */}
        <div className="footer-form col-md-4">
          <h3>Solicita tu asesoría</h3>

          <div style={{ display: "flex", flexDirection: "column" }}>
            <Input
              placeholder="Nombre"
              variant="Simple"
              value={values.name}
              onChange={handleChange("name")}
              onBlur={handleBlur("name")}
              error={setErrorFormSimpleUtil(errors, touched, "name")}
              success={!setErrorFormSimpleUtil(errors, touched, "name")}
            />

            <Input
              placeholder="Empresa"
              variant="Simple"
              value={values.empresa}
              onChange={handleChange("empresa")}
              onBlur={handleBlur("empresa")}
              error={setErrorFormSimpleUtil(errors, touched, "empresa")}
              success={!setErrorFormSimpleUtil(errors, touched, "empresa")}
            />

            <Input
              placeholder="Teléfono"
              variant="Simple"
              value={values.phone}
              onChange={handleChange("phone")}
              onBlur={handleBlur("phone")}
              error={setErrorFormSimpleUtil(errors, touched, "phone")}
              success={!setErrorFormSimpleUtil(errors, touched, "phone")}
            />

            <Button
              text={loading ? "Enviando..." : "Solicitar asesoría"}
              action={() => handleSubmit(values)}
              disabled={!isValid || loading}
            />
          </div>
        </div>

        {/* CONTACTO + REDES */}
        <div className="footer-left col-md-4">
          <div className="row">
            <div className="col-12">
              <div className="footer-contact-container">
                <h3>{footer[0]?.footerContacto?.titulo}</h3>
                {footer[0]?.footerContacto?.footerContactoData?.map((detail, index) => {
                  const IconComponent = iconComponents[detail.iconoNombre];
                  return (
                    <div key={index} className="contact-detail">
                      <div className="icon">{IconComponent && <IconComponent />}</div>
                      <span>{detail.titulo}</span>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <div className="footer-socials">
                <h3 dangerouslySetInnerHTML={{ __html: footer[0]?.footerContacto?.tituloRedesSociales || "" }} />
                <div className="content-footer-socials">
                  {footer[0]?.footerContacto?.redesSociales?.map((social, index) => {
                    const Icon = iconMap[social.icono];
                    return (
                      <a key={index} href={social.link} target="_blank" rel="noreferrer" className={`icon ${social.plataforma}`}>
                        {Icon && <Icon />}
                      </a>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* MAPA */}
        <div className="footer-contact col-md-4">
          <h3>{footer[0]?.footerVisitanosComponent?.titulo}</h3>
          <Mapa />
        </div>
      </div>
    </section>
  );
};

export default Asesoria;
